import { createReducer } from '@reduxjs/toolkit';
import { TYPES } from '../../common/constants';

const fetchNotesDone = (_, { payload }) => {
    return payload
}

const clearNotesDOne = () => {
  return initialState
}
const initialState = []

export default createReducer(initialState, {
  [TYPES.FETCH_NOTES]:fetchNotesDone,
  [TYPES.CLEAR_NOTES]:clearNotesDOne

});


